/**
 * Application Constants
 */

// Solana Configuration
export const SOLANA_CONFIG = {
  NETWORK: 'mainnet-beta',
  RPC_URL: import.meta.env.VITE_SOLANA_RPC_URL || 'https://api.mainnet-beta.solana.com',
  COMMITMENT: 'confirmed'
}

// Pythenians NFT Collection
export const PYTHENIANS_CONFIG = {
  COLLECTION_ADDRESS: 'pyTh2UtBKfuDW6KCdT3swospYeoLmmKaGujWA91Moru', // Verified collection mint
  COLLECTION_NAME: 'Pythenians',
  MARKETPLACES: {
    MAGIC_EDEN: 'https://magiceden.io/marketplace/pythenians',
    TENSOR: 'https://www.tensor.trade/trade/pythenians',
    COINGECKO: 'https://www.coingecko.com/en/nft/pythenians'
  }
}

// Discord Configuration
export const DISCORD_CONFIG = {
  MULTIPLIER_LABEL: 'Discord Role Multiplier'
}

// Twitter Configuration
export const TWITTER_CONFIG = {
  LINK_BONUS: 1000,
  REDIRECT_URI: '/auth/twitter/callback'
}

// Scoring Configuration
export const SCORING_CONFIG = {
  CORE_POSITIONS: ['PYTH'],
  PARTNER_POSITIONS: ['JUP', 'KMNO'],
  POSITION_LABELS: {
    PYTH: 'PYTH Staking',
    JUP: 'JUP Staking',
    KMNO: 'KMNO Staking'
  },
  POSITION_ICONS: {
    PYTH: { type: 'image' },
    JUP: { type: 'emoji', emoji: '\u{1FA90}' },
    KMNO: { type: 'emoji', emoji: '\u{1F48E}' }
  },
  STREAK_TIERS_PYTH: [
    { days: 730, mult: 3.5, label: '2+ years' },
    { days: 365, mult: 2.7, label: '1+ year' },
    { days: 180, mult: 2.0, label: '6+ months' },
    { days: 90, mult: 1.5, label: '3+ months' },
    { days: 0, mult: 1.0, label: 'New' },
  ],
  STREAK_TIERS_PARTNER: [
    { days: 730, mult: 2.0, label: '2+ years' },
    { days: 365, mult: 1.8, label: '1+ year' },
    { days: 180, mult: 1.6, label: '6+ months' },
    { days: 90, mult: 1.3, label: '3+ months' },
    { days: 0, mult: 1.0, label: 'New' },
  ],
}

// Leaderboard Configuration
export const LEADERBOARD_CONFIG = {
  MAX_USERS: 3000,
  PAGE_SIZE: 50,
  UPDATE_INTERVAL: 86400000 // 24 hours in milliseconds
}

// Badge Configuration
export const BADGES = {
  ORACLE: { name: 'Oracle', icon: '🔮', color: 'purple' },
  GUARDIAN: { name: 'Guardian', icon: '🛡️', color: 'blue' },
  CONTRIBUTOR: { name: 'Contributor', icon: '⚡', color: 'cyan' },
  EARLY_ADOPTER: { name: 'Early Adopter', icon: '🌟', color: 'yellow' },
  GOVERNANCE_VOTER: { name: 'Governance Voter', icon: '🗳️', color: 'green' },
  GOVERNANCE_MASTER: { name: 'Governance Master', icon: '👑', color: 'gold' },
  STAKER: { name: 'Staker', icon: '💎', color: 'indigo' },
  MAX_STAKER: { name: 'Max Staker', icon: '💰', color: 'emerald' }
}

// API Endpoints
export const API_ENDPOINTS = {
  AUTH_WALLET: '/.netlify/functions/auth-wallet',
  VERIFY_NFT: '/.netlify/functions/verify-nft',
  GET_USER: '/.netlify/functions/get-user',
  GET_SCORES: '/.netlify/functions/get-scores',
  GET_LEADERBOARD: '/.netlify/functions/leaderboard',
  LINK_DISCORD: '/.netlify/functions/link-discord',
  LINK_TWITTER: '/.netlify/functions/link-twitter',
  SNAPSHOT: '/.netlify/functions/admin-snapshot',
  RECALCULATE: '/.netlify/functions/admin-recalculate'
}

// UI Constants
export const UI_CONFIG = {
  TOAST_DURATION: 5000,
  ANIMATION_DURATION: 300,
  MOBILE_BREAKPOINT: 768,
  TABLET_BREAKPOINT: 1024
}
